import { FolderKanban } from 'lucide-react';

const ProjectsButton = ({ onClick, hasActiveJobs = false }) => {
  return (
    <button
      onClick={onClick}
      data-testid="open-projects-button"
      className="relative p-2.5 backdrop-blur-xl bg-black/40 border border-neon-red/30 hover:border-neon-red hover:bg-neon-red/20 text-white transition-all duration-300"
      title="Proyectos y agentes"
    >
      <FolderKanban className="w-4 h-4" />
      {hasActiveJobs && (
        <span
          className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-neon-red rounded-full animate-pulse"
          data-testid="active-jobs-indicator"
          style={{ boxShadow: '0 0 8px rgba(255, 0, 51, 0.9)' }}
        />
      )}
    </button>
  );
};

export default ProjectsButton;
